export enum DashboardType {
    TIER_ONE = 1,
    TIER_TWO,
    TIER_THREE,
}